import style from "./SubscribeToPremium.module.css";

import Logo from "@/ui/logo/Logo";
import Icon from "@/ui/icon/Icon";

import { Link } from "react-router-dom";

function SubscribeToPremium() {
	return (
		<div className={style.card}>
			<div className={style.header}>
				<div className={style.logo}>
					<Logo mini={true} />
				</div>
			</div>

			<div className={style.body}>
				<div className={style.title}>Mentorios premium</div>

				<div className={style.info}>
					<p>
						Izaberite svoj plan i uživajte u cijeloj kolekciji
						sadržaja.
					</p>
				</div>

				<Link to="/plans" className={style.button}>
					<span>Pretplatite se</span>
					<div className={style.icoHolder}>
						<span className={style.defaultIcon}>
							<Icon icon="fa-arrow-right-long" />
						</span>
						<span className={style.hoverIcon}>
							<Icon icon="fa-shopping-basket" />
						</span>
					</div>
				</Link>
			</div>
		</div>
	);
}

export default SubscribeToPremium;
